import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">
        <Link to="/" className="nav-logo">
          <div className="nav-mark">F</div>
          FaithConnect
        </Link>
        <div className="nav-links">
          <NavLink to="/features">Features</NavLink>
          <NavLink to="/pricing">Pricing</NavLink>
          <NavLink to="/blog">Blog</NavLink>
          <NavLink to="/faq">FAQ</NavLink>
          <NavLink to="/contact">Contact Us</NavLink>
        </div>
        <div className="nav-auth">
          <Link
            to="https://admin.kelvinkwesidanquah.com/login"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-login"
          >
            Log in
          </Link>
          <Link
            to="https://admin.kelvinkwesidanquah.com/register"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-cta"
          >
            Sign up
          </Link>
        </div>
        <button className={`burger ${mobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu} aria-label="Menu">
          <span></span><span></span><span></span>
        </button>
      </div>
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <NavLink to="/features">Features</NavLink>
        <NavLink to="/pricing">Pricing</NavLink>
        <NavLink to="/blog">Blog</NavLink>
        <NavLink to="/faq">FAQ</NavLink>
        <NavLink to="/contact">Contact Us</NavLink>
        <Link to="/login">Log in</Link>
        <Link to="/signup">Sign up</Link>
      </div>
    </nav>
  );
}

export default Navbar;